import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import AddEditUser from '.';
const AddEditUserDialog = ({ open, onClose, edit = false, user, onSubmitUser }) => {
    const formRef = useRef(null);
    const { t } = useTranslation();
    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.submitForm();
        }
    };
    return (_jsx(CustomDialog, { open: open, onClose: onClose, title: edit ? t('users.editUser') : t('users.addUser'), backgroundVariant: 'white', actions: _jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: true, onClick: onClose, variant: 'outlined', color: 'inherit', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', onClick: handleSubmit, size: 'large', children: edit ? t('actions.editNow') : t('actions.addNow') })] }), children: _jsx(AddEditUser, { ref: formRef, dialog: true, edit: edit, user: user, onSubmit: onSubmitUser }) }));
};
export default AddEditUserDialog;
